import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{
  withBorder?: boolean;
  yPadding?: number;
}>()((theme, { withBorder, yPadding = 2 }) => ({
  button: {
    borderRadius: '10px',
    backgroundColor: theme.palette.paper.backgroundColor,
    border: withBorder
      ? `1px solid ${theme.palette.paper.borderColor}`
      : `1px solid ${theme.palette.paper.backgroundColor}`,
    color: theme.palette.primary.main,
    textTransform: 'capitalize',
    transition: 'all 0.15s linear',
    boxShadow: 'none !important',
    padding: theme.spacing(yPadding, 1),
    '&:hover': {
      border: `1px solid ${theme.palette.paper.hoverBorderColor}`,

      backgroundColor: theme.palette.paper.hoverBackgroundColor,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1rem',
    },
  },
  circularProgress: {
    color: theme.palette.primary.main,
  },
}));
